import { TableCell } from '@mui/material';
import { SubjectAreaNames } from '../../../interfaces/EOAInterface';
import { Course, Term } from '../../../interfaces/TranscriptsInterface';

import './TranscriptPrintViewCell.css';

interface TranscriptPrintViewCellProps {
  subjectArea: SubjectAreaNames;
  term: Term;
}

function TranscriptPrintViewCell({ subjectArea, term }: TranscriptPrintViewCellProps) {

  let data = term.subject_areas.find(subjectAreaData => subjectAreaData.name === subjectArea);

  if (!data) return <TableCell className="border-left" />;

  return (
    <TableCell className="border-left data-cell">
      { data.courses.length > 1 ?
        <TranscriptPrintViewCellPreview data={data.courses} />
        :
        <TranscriptPrintViewCellFull data={data.courses[0]} />
      }
    </TableCell>
  );
}

interface TranscriptPrintViewCellFullProps {
  data: Course;
}

function TranscriptPrintViewCellFull({ data }: TranscriptPrintViewCellFullProps) {
  return (
    <div className="print-view-cell-full">
      <div className="course-info">
        <p className="no-margin course-name">{data.name}</p>
        <p className="no-margin course-code">({data.code})</p>
        <p className="no-margin">{data.num_credits} credits</p>
      </div>
      <p className="no-margin grade-data">{data.letter_grade || data.number_grade}</p>
    </div>
  );
}

interface TranscriptPrintViewCellPreviewProps {
  data: Course[];
}

function TranscriptPrintViewCellPreview({ data }: TranscriptPrintViewCellPreviewProps) {
  return (
    <>
      {
        data.map((course, index) => (
          <div key={index} className="course-preview">
            <p className="no-margin preview-course-name">{course.name}</p>
            <p className="no-margin grade-data">{course.letter_grade || course.number_grade}</p>
          </div>
        ))
      }
    </>
  );
}

export default TranscriptPrintViewCell;